import { Link } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'

export default function Dashboard() {
    const { user, isSysAdmin } = useAuth()

    const menuItems = [
        {
            to: '/create-timesheet',
            icon: '📝',
            title: 'Create Timesheet',
            description: 'Start a new timesheet entry',
            color: 'bg-blue-500',
            show: true,
        },
        {
            to: '/timesheets',
            icon: '📂',
            title: 'Load Timesheet',
            description: 'View and edit existing timesheets',
            color: 'bg-green-500',
            show: true,
        },
        {
            to: '/manage-timesheets',
            icon: '📋',
            title: 'Manage Timesheets',
            description: 'View and manage all timesheets',
            color: 'bg-indigo-500',
            show: isSysAdmin || user?.canManageTimesheets,
        },
        {
            to: '/admin/email-packing-slip',
            icon: '📧',
            title: 'Email Packing Slip',
            description: 'Send packing slips to customers',
            color: 'bg-purple-500',
            show: isSysAdmin || user?.canPackingSlipEmail,
        },
        {
            to: '/job-list',
            icon: '📋',
            title: 'Jobs',
            description: 'View all job numbers and details',
            color: 'bg-cyan-500',
            show: isSysAdmin || user?.canJobList,
        },
        {
            to: '/inventory',
            icon: '📦',
            title: 'Inventory',
            description: 'View parts and materials',
            color: 'bg-orange-500',
            show: isSysAdmin || user?.canInventory,
        },
        {
            to: '/admin/users',
            icon: '👥',
            title: 'Users',
            description: 'Manage user accounts',
            color: 'bg-pink-500',
            show: isSysAdmin || user?.canUsers,
        },
        {
            to: '/admin/signature-copy',
            icon: '✍️',
            title: 'Signature Copy',
            description: 'Copy signatures between timesheets',
            color: 'bg-yellow-500',
            show: isSysAdmin || user?.canSigCopy,
        },
        {
            to: '/admin/sync',
            icon: '🔄',
            title: 'Sync Dashboard',
            description: 'QuickBooks sync and export',
            color: 'bg-teal-500',
            show: isSysAdmin,
        },
    ].filter(item => item.show)

    return (
        <div>
            {/* Header */}
            <div className="page-header">
                <h1 className="page-title">Welcome, {user?.fullName || user?.userName}!</h1>
                <p className="text-blue-100 mt-1">What would you like to do today?</p>
            </div>

            {/* Menu Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-8">
                {menuItems.map((item) => (
                    <Link
                        key={item.to}
                        to={item.to}
                        className="bg-white rounded-xl shadow-md hover:shadow-lg transition-all duration-200 overflow-hidden group"
                    >
                        <div className="flex items-center p-5">
                            <div className={`${item.color} w-12 h-12 rounded-lg flex items-center justify-center text-xl mr-4 group-hover:scale-110 transition-transform`}>
                                {item.icon}
                            </div>
                            <div className="flex-1">
                                <h3 className="font-semibold text-gray-800">{item.title}</h3>
                                <p className="text-gray-500 text-sm">{item.description}</p>
                            </div>
                            <svg
                                className="w-5 h-5 text-gray-400 group-hover:translate-x-1 transition-transform"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                            >
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                            </svg>
                        </div>
                    </Link>
                ))}
            </div>

            {/* Quick Stats */}
            <div className="bg-white rounded-xl shadow-md p-6">
                <h2 className="text-lg font-semibold text-gray-700 mb-4">Quick Info</h2>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                    <div className="text-center p-4 bg-gray-50 rounded-lg">
                        <p className="text-2xl font-bold text-rdi-blue">-</p>
                        <p className="text-sm text-gray-500">My Timesheets</p>
                    </div>
                    <div className="text-center p-4 bg-gray-50 rounded-lg">
                        <p className="text-2xl font-bold text-yellow-500">-</p>
                        <p className="text-sm text-gray-500">Pending</p>
                    </div>
                    <div className="text-center p-4 bg-gray-50 rounded-lg">
                        <p className="text-2xl font-bold text-green-500">-</p>
                        <p className="text-sm text-gray-500">Submitted</p>
                    </div>
                    <div className="text-center p-4 bg-gray-50 rounded-lg">
                        <p className="text-2xl font-bold text-purple-500">-</p>
                        <p className="text-sm text-gray-500">This Month</p>
                    </div>
                </div>
            </div>
        </div>
    )
}